<script setup>
import { computed } from "vue";

// Single source of the track type colors, shared by lists, map markers and the map legend
const TRACK_TYPE_COLORS = {
    rb: "#1d4ed8",
    gpx: "#c2410c",
};
// Brighter fills so markers stand out on the map
const TRACK_TYPE_MARKER_COLORS = {
    ...TRACK_TYPE_COLORS,
    gpx: "#ea580c",
};

const props = defineProps({
    type: { type: String, required: true },
    size: { type: Number, default: null },
    variant: { type: String, default: "glyph" },
});

const pixelSize = computed(() => props.size ?? (props.variant === "marker" ? 30 : 18));
const glyphSize = computed(() => (props.variant === "marker" ? 16 : pixelSize.value));
</script>

<template>
    <span
        v-if="TRACK_TYPE_COLORS[type]"
        class="inline-flex shrink-0 items-center justify-center"
        :class="{
            'box-border rounded-full border-2 border-white text-white shadow-[0_1px_4px_rgba(0,0,0,.35)]':
                variant === 'marker',
        }"
        :style="{
            width: `${pixelSize}px`,
            height: `${pixelSize}px`,
            ...(variant === 'marker' ? { backgroundColor: TRACK_TYPE_MARKER_COLORS[type] } : { color: TRACK_TYPE_COLORS[type] }),
        }"
    >
        <svg
            :width="glyphSize"
            :height="glyphSize"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
        >
            <!-- Lucide "book-open-text" -->
            <template v-if="type === 'rb'">
                <path d="M12 7v14" />
                <path d="M16 12h2" />
                <path d="M16 8h2" />
                <path
                    d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"
                />
                <path d="M6 12h2" />
                <path d="M6 8h2" />
            </template>
            <!-- Custom "waypoints" line icon (5c) -->
            <template v-else>
                <circle
                    cx="4"
                    cy="17"
                    r="2.5"
                />
                <circle
                    cx="11"
                    cy="7"
                    r="2.5"
                />
                <circle
                    cx="20"
                    cy="15"
                    r="2.5"
                />
                <path d="M5.43 14.95 9.57 9.05" />
                <path d="M12.87 8.66 18.13 13.34" />
            </template>
        </svg>
    </span>
</template>
